<template>
  <div class="plan__date">
    <div style="display: none">
      <div class="billing-period-end">
        {{ billing.current_period_end_datetime }}
      </div>
      <div class="billing-period-end-local">
        {{ formatDateDebug(billing.current_period_end_datetime) }}
      </div>
      <div class="billing-trial-start">
        {{ billing.trial_start_datetime }}
      </div>
      <div class="billing-trial-start-local">
        {{ formatDateDebug(billing.trial_start_datetime) }}
      </div>
      <div class="billing-trial-end">
        {{ billing.trial_end_datetime }}
      </div>
      <div class="billing-trial-end-local">
        {{ formatDateDebug(billing.trial_end_datetime) }}
      </div>
    </div>

    <p class="plan__date-text">
      Billed
      <span class="plan__date-text--black-text"
        >once per {{ billing.plan.labels.period }}.</span
      >
      <span v-if="billing.cancel_at_period_end">
        Active until
        <span class="plan__date-text--black-text plan__date-date"
          >{{ billing.billingPeriodEnd }}.</span
        >
      </span>
      <span v-else>
        Next billing on
        <span class="plan__date-text--black-text plan__date-date"
          >{{ billing.billingPeriodEnd }}.</span
        >
        You will be charged
        <span class="plan__date-text--black-text plan__date-date">{{
          billing.nextBillingPrice.perPeriod
        }}</span>
        on this date.
      </span>
    </p>
    <p v-if="billing.is_trial" class="plan__date-text plan__trial-info">
      Trial period: <span>{{ billing.trialMode }}</span>
    </p>
  </div>
</template>

<script setup lang="ts">
import { BillingView } from '@/models/billing'

import { formatTrialDateDebug } from '@/helpers/time'

defineProps<{
  billing: BillingView
}>()

function formatDateDebug(dt: string): string {
  return formatTrialDateDebug(dt)
}
</script>
